// @ts-check
import React, { useCallback } from 'react';
import { useMutation } from 'react-query';
import { usePortalConfig } from 'shared/context/PortalConfig';
import api from 'utils/api';
import PromiseButton from 'shared/components/PromiseButton';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import { getErrorMessage } from 'utils/reduxFormWrapper';

/** @typedef {{
  appointmentId: string;
  onSuccess(): void;
  onFailure?(message: string): void;
  className?: string;
}} CompleteAppointmentButtonProps */

/** @type { React.FC<CompleteAppointmentButtonProps> } */
export const CompleteAppointmentButton = (props) => {
  const {
    appointmentId,
    onSuccess,
    className = 'btn btn-mini btn-success',
    children,
  } = props;

  const { apiPrefix } = usePortalConfig();

  const mutation = useMutation((/** @type { string } */ appointmentId) =>
    api
      .put(`${apiPrefix}/appointments/${appointmentId}/complete`)
      .then((resp) => resp.data)
  );

  const onSubmit = useCallback(() => {
    return mutation.mutateAsync(appointmentId).then(
      (_data) => {
        FlashMessageActions.flashSuccess({
          message: 'Appointment completed',
        });
        return onSuccess();
      },
      (err) => {
        console.error(err);
        FlashMessageActions.flashInfo({
          message: getErrorMessage(err),
        });
      }
    );
  }, [appointmentId, onSuccess]);

  return (
    <PromiseButton
      className={`_CompleteAppointmentButton ${className || ''}`}
      onClick={onSubmit}
    >
      {children}
    </PromiseButton>
  );
};
